export class AppSession {
    email: string;
    lastLogin: string;
    phone: string;
    posName1: string;
    posName2: string;
    token: string;
    puntoVenta: string;
    purchaseCommission: string;
    es_pin: boolean;
    cambiar_pin: boolean;
    tiene_2fa: boolean;
    evalua_2fa: boolean;
    uid: string;
    tipo_modelo: string;


    constructor({
        email = undefined,
        last_login = undefined,
        phone_number = undefined,
        pos_name_1 = undefined,
        pos_name_2 = undefined,
        token = undefined,
        puntoVenta = "",
        purchaseCommission = undefined,
        es_pin = false,
        cambiar_pin = false,
        tiene_2fa = false,
        evalua_2fa = false,
        uid = undefined,
        tipo_modelo = undefined,
    }: any) {
        this.email = email;
        this.lastLogin = last_login;
        this.phone = phone_number;
        this.posName1 = pos_name_1;
        this.posName2 = pos_name_2;
        this.token = token;
        this.puntoVenta = puntoVenta;
        this.purchaseCommission = purchaseCommission;
        this.es_pin = es_pin;
        this.cambiar_pin = cambiar_pin;
        this.tiene_2fa = tiene_2fa;
        this.evalua_2fa = evalua_2fa;
        this.uid = uid;
        this.tipo_modelo = tipo_modelo;
    }

}